module.exports = __webpack_public_path__ + "f6a6162335296b84e6fd6aa3c9a9171c.svg";